import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SimpleAdvancedPopup = ({ open, onClose, onSelect }) => {

  const handleSelect = (selection) => {
    onSelect(selection);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
    <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        width: 300,
        borderRadius: 2,
        outline: 'none',
      }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <h3>Select Type</h3>
        <hr></hr>
        {/* <Button
          variant="contained"
          onClick={() => handleSelect('simple')}
          sx={{
            mt: 2,
            width: '100%',
            backgroundColor: 'var(--button-color)',
            color: 'white',
            fontWeight: 'normal',
            textTransform: 'none',
            ":hover": {
              backgroundColor: 'var(--button-hover-color)',
            },
          }}
        >
          Simple
        </Button> */}
        <Button
          variant="contained"
          onClick={() => handleSelect('advanced')}
          sx={{
            mt: 2,
            width: '100%',
            backgroundColor: 'var(--button-color)',
            color: 'white',
            fontWeight: 'normal',
            textTransform: 'none',
            ":hover": {
              backgroundColor: 'var(--button-hover-color)',
            },
          }}
        >
          Parameter Valid Values
        </Button>
        <Button
          variant="contained"
          onClick={() => handleSelect('api')}
          sx={{
            mt: 2,
            width: '100%',
            backgroundColor: 'var(--button-color)',
            color: 'white',
            fontWeight: 'normal',
            textTransform: 'none',
            ":hover": {
              backgroundColor: 'var(--button-hover-color)',
            },
          }}
        >
          Other Services
        </Button>
      </Box>
    </Modal>
  );
};

export default SimpleAdvancedPopup;